import React, { useCallback, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import useStyles from './MissionForm.styles';
import MissionName from './MissionName';
import ClientSelect from '../../../client/components/form/ClientSelect';
import HeaderActions from './header/HeaderActions';
import MissionContactList from './contact/list/MissionContactList';
import { MissionExact } from '../../models/Mission';
import missionFormSchema from '../../schemas/missionFormSchema';
import sharedMissionFormSchema from '../../schemas/sharedMissionFormSchema';
import MissionDetails from '../details/MissionDetails';
import MissionFormActions from './actions/MissionFormActions';
import Can, { useClientContext } from '../../../common/contexts/abilityContext';

const MissionForm = ({ mission, onBackClick, onReuploadSuccess, onSubmit }) => {
  const classes = useStyles();

  const [pipelineCenterlines, setPipelineCenterlines] = useState();

  const validationSchema = mission.sharedRow ? sharedMissionFormSchema : missionFormSchema;

  const handlePipelineCenterlinesValidationSuccess = useCallback((centerlines) => {
    setPipelineCenterlines(centerlines);
  }, []);

  const handleSubmit = useCallback(
    (values, actions) => {
      onSubmit(values, actions);
      actions.setSubmitting(false);
    },
    [onSubmit]
  );

  const clientId = useClientContext();

  return (
    <Formik initialValues={mission} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {() => (
        <Form>
          <div className={classes.header}>
            <MissionName />
            <Field type="hidden" name="clientId" value={clientId} />
            {!mission.sharedRow && (
              <Can do="create" on="client" passThrough>
                {(canChangeClient) => <ClientSelect disabled={!canChangeClient} />}
              </Can>
            )}
            <HeaderActions mission={mission} onBackClick={onBackClick} />
          </div>
          <div className={classes.container}>
            <MissionFormActions
              mission={mission}
              onReuploadSuccess={onReuploadSuccess}
              onPipelineCenterlinesValidationSuccess={handlePipelineCenterlinesValidationSuccess}
            />
            <MissionDetails mission={mission} pipelineCenterlines={pipelineCenterlines} />
            <MissionContactList />
          </div>
        </Form>
      )}
    </Formik>
  );
};

MissionForm.propTypes = {
  mission: MissionExact.isRequired,
  onBackClick: PropTypes.func,
  onReuploadSuccess: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
};

MissionForm.defaultProps = {
  onBackClick: undefined,
  onReuploadSuccess: undefined,
};
export default MissionForm;
